import { render, staticRenderFns } from "./SmartClassifierNewIntent.vue?vue&type=template&id=4c23a76e&scoped=true&"
import script from "./SmartClassifierNewIntent.vue?vue&type=script&lang=js&"
export * from "./SmartClassifierNewIntent.vue?vue&type=script&lang=js&"
import style0 from "./SmartClassifierNewIntent.vue?vue&type=style&index=0&id=4c23a76e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c23a76e",
  null
  
)

export default component.exports